import { jsx } from 'react/jsx-runtime';
import { BlurUpImage as BlurUpImage$1 } from '@sketch/components';
import '../../analytics/index.js';
import { useAnalytics } from '../../analytics/analytics.context.js';

/**
 * Wrapper for BlurUpImage component that triggers an ananlytics event when the
 * component loads.
 */
const BlurUpImage = props => {
    const { pageLoad } = useAnalytics();
    const handleImageLoad = (event) => {
        var _a;
        (_a = props.onLoad) === null || _a === void 0 ? void 0 : _a.call(props, event);
        pageLoad.observeCustomElement({
            element: event.currentTarget,
            identifier: 'blur-up-image',
        });
    };
    return jsx(BlurUpImage$1, Object.assign({}, props, { onLoad: handleImageLoad }));
};

export { BlurUpImage };
